// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicLineClamp_root__GVQIy"};